// src/components/Q8Breadcrumbs.js
import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs, Typography, Box } from "@mui/material";
import { HomeOutlined as HomeIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
import "../../src/App.css";

const Q8Breadcrumbs = ({ links = [], variant = "primary" }) => {
  return (
    <Breadcrumbs
      variant={variant}
      aria-label="breadcrumb"
      className="breadcrumbs-container"
    >
      <Box sx={{mb: 1}}>
        <Link color="inherit" to="/">
          <HomeIcon id="home-icon" sx={{ mr: 1}} />
          Homepage
        </Link>
      </Box>
      {links.map((link, index) => {
        const isLast = index === links.length - 1;
        return isLast ? (
          <Typography key={link.label} color="inherit">
            {link.label}
          </Typography>
        ) : (
          <Link key={link.label} color="inherit" to={link.href || "/"}>
            {link.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

Q8Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
  variant: PropTypes.oneOf(["primary", "secondary"]),
};

Q8Breadcrumbs.defaultProps = {
  links: [],
  variant: "primary",
};

export default Q8Breadcrumbs;
